export default {
  name: 'PhotoDune',
  abbreviation: 'PD',
  domain: 'photodune.net',
  google_analytics_id: 'UA-11834194-35',
  google_remarketing_label: 'rsMOCJ2EugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. animals',
  ui: {
    item_list_views: [
      {
        value: 'grid',
        label: 'Grid'
      }
    ]
  },
  assets_domains: {
    item_thumbnail: 'thumb-pd.s3.envato.com',
    item_image: 'image-pd.s3.envato.com'
  },
  asset_type: 'stock photo',
  search_query: {
    default_sort_by: 'trending'
  },
  item_view: {
    footer_link: {
      label: 'Similar images',
      href: '/search?item_id={id}'
    }
  },
  hide_sidebar_by_default: true,
  homepage: {
    newest_items_page_size: 28,
    newest_items_square: false
  }
}
